export const timelineExperience = [
    {
        name: "Accenture",
        experienceYearRange: "2021-Present",
        role: "Full Stack Developer",
    },
    {
        name: "Tata Consultancy Services (TCS)",
        experienceYearRange: "2018-2021",
        role: "Frontend Developer",
    },
]